import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse, PaginatedResponse, Convive, CreateConviveRequest } from '../shared/models/api.models';

export interface ConvivesListParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root'
})
export class ConvivesService {
  private readonly apiUrl = `${environment.apiUrl}/convives`;

  constructor(private http: HttpClient) {}

  getConvives(params: ConvivesListParams = {}): Observable<PaginatedResponse<Convive>> {
    let httpParams = new HttpParams();
    
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.limit) httpParams = httpParams.set('limit', params.limit.toString());
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.isActive !== undefined) httpParams = httpParams.set('isActive', params.isActive.toString());
    if (params.sortBy) httpParams = httpParams.set('sortBy', params.sortBy);
    if (params.sortOrder) httpParams = httpParams.set('sortOrder', params.sortOrder);

    return this.http.get<PaginatedResponse<Convive>>(this.apiUrl, { params: httpParams });
  }

  getConvive(id: string): Observable<ApiResponse<Convive>> {
    return this.http.get<ApiResponse<Convive>>(`${this.apiUrl}/${id}`);
  }

  createConvive(convive: CreateConviveRequest): Observable<ApiResponse<Convive>> {
    return this.http.post<ApiResponse<Convive>>(this.apiUrl, convive);
  }

  updateConvive(id: string, convive: Partial<CreateConviveRequest>): Observable<ApiResponse<Convive>> {
    return this.http.patch<ApiResponse<Convive>>(`${this.apiUrl}/${id}`, convive);
  }

  deleteConvive(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }

  toggleConviveStatus(id: string, isActive: boolean): Observable<ApiResponse<Convive>> {
    return this.http.patch<ApiResponse<Convive>>(`${this.apiUrl}/${id}`, { isActive });
  }

  getAnniversaires(joursAVenir: number = 30): Observable<any[]> {
    const httpParams = new HttpParams().set('joursAVenir', joursAVenir.toString());
    return this.http.get<any[]>(`${this.apiUrl}/anniversaires`, { params: httpParams });
  }

  exportConvives(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/export/convives`, {
      responseType: 'blob'
    });
  }
}
